import React from 'react'
import { Icon } from 'react-icons-kit'
import { downloadCloud } from 'react-icons-kit/feather/downloadCloud'

import SlidingPane from '../SlidePane'
import styles from './Header.module.scss'

/**
* @author zilahir
* @function Header
* */

const Header = () => (
	<div className={styles.header}>
		<div className={styles.headerIcon}>
			<Icon icon={downloadCloud} />
		</div>
		<SlidingPane />
	</div>

)

export default Header
